__webpack_require__.p = "/React-Solo-Capstone/";